import React from 'react'
import styled from 'styled-components';

const DivConteiner = styled.div`
  top: 0;
  left: 0;
  display: flex;
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
  z-index: 9999;
  justify-content: center;
  align-items: center;
`;

const DivContent = styled.div`
  border-radius: 12px;
  width: 350px;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  padding: 20px;
`;

const DivButton = styled.div`
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  height: 60%;
`;

const ButtonCancelar = styled.button`
  width: 70px;
  height: 35px;
  background: #0047B6;
  color: #fff;
  border: transparent;
  border-radius: 24px;
  font-size: 16px;
  font-family: Public Sans;
`;

const ButtonSubmit = styled.button`
  width: 70px;
  height: 35px;
  background: #C7503C;
  color: #fff;
  border: transparent;
  border-radius: 24px;
  font-size: 16px;
  font-family: Public Sans;
`;

const SpanTitle = styled.span`
  font-size: 20px;
  height: 100%;
  font-family: Public Sans;
`;

const DeleteModal = ({ handleInativarTema, setIdTema, idTema }) => {

  const handleCancelar = () => {
    setIdTema();
  };

  return (
    <DivConteiner onClick={() => handleCancelar()}>
      <DivContent>
        <SpanTitle>Tem certeza que deseja inativar o tema?</SpanTitle>
        <DivButton>
          <ButtonSubmit
            onClick={() => handleInativarTema(idTema)}
          >
            Sim
          </ButtonSubmit>
          <ButtonCancelar
            onClick={() => handleCancelar()}
          >
            Não
          </ButtonCancelar>
        </DivButton>
      </DivContent>
    </DivConteiner>
  );
};
export default DeleteModal;